// Lib
import React, { ReactElement } from 'react';
import classNames from 'classnames';

// Components
import Icon from '../../components/icons/Icon';

// Styles
import './ToastDismissButton.scss';

const ToastDismissButton = (
    props: React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
): ReactElement => (
    <div className="ToastDismissButton">
        <button {...props} className={classNames('dismiss-button', props.className)}>
            <Icon name="toast-dismiss" />
        </button>
    </div>
);

export default ToastDismissButton;
